import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Delete_Modal from "../../../../../../../../common/common_modal/delete_model/Delete_Modal";
import {
  Delete,
  GetAllIntermediate,
} from "../../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { useDispatch, useSelector } from "react-redux";
import { faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDate } from "../../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../../utils/fixIDS";
import Intermediate_Check_Edit_Offcanvas from "../Intermediate_Check_Edit_Offcanvas/Intermediate_Check_Edit_Offcanvas";

function Intermediat_Check_table({
  handleClose,
  data,
  currentPage,
  setCurrentPage,
  fetchCustomers,
}) {
  const [success, setSuccess] = useState(false);

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const totalPages = Math.ceil(data.total_pages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      await dispatch(Delete(deleteId));

      setShowDeleteModal(false);
      await dispatch(
        GetAllIntermediate({
          // instrument_id: searchName.instrument_id || "",
          // instrument_unique_id: searchName.instrument_unique_id || "",
          // calibrate_instrument: searchName.calibrate_instrument || "",
          page: 1,
          // per_page: data?.data.per_page,
        }),
      );
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.intermediate_check.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.intermediate_check.Delete,
  );

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Date</th>
                  <th>Instrument</th>
                  <th>Instrument ID</th>
                  <th>Calibrate By</th>
                  <th>Calibrate Instrument By</th>
                  <th>Weight in Grams</th>
                  <th>STD Value in grams</th>
                  <th>Observations</th>
                  <th>Mean</th>
                  <th>Deviation</th>
                  <th>Remark</th>
                  <th>Accuracy Acceptance</th>
                  <th>Action</th>
                </tr>

                {/* <tr>
                  <th>OBS 01</th>
                  <th>OBS 02</th>
                  <th>OBS 03</th>
                  <th>OBS 04</th>
                  <th>OBS 05</th>
                </tr> */}
              </thead>

              <tbody>
                {data?.data?.map((row, index) =>
                  row.Intermediate_Check_Observations?.length > 0 ? (
                    row.Intermediate_Check_Observations.map((obs, i) => (
                      <tr key={`${index}-${i}`}>
                        {i === 0 && (
                          <>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {(currentPage - 1) *
                                (data?.per_page || data?.data?.length || 0) +
                                index +
                                1}
                            </td>

                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {formatDate(row?.date)}
                              {/* {formatDate(row?.createdAt)} */}
                            </td>

                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.Instrument_Management?.instrument_name}
                            </td>

                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.Instrument_Management?.unique_id}
                            </td>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.Calibrated_By?.instrument_name}
                            </td>

                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.User?.name}
                            </td>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.weight_in_grams}
                            </td>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.std_value_in_grams}
                            </td>
                          </>
                        )}

                        {/* <td>{Number(obs.weight_ingram).toFixed(2)}</td>
                        <td>{Number(obs.std_value).toFixed(2)}</td> */}
                        <td>
                          OBS {obs.observation_no}{" "}
                          {Number(obs.observation_value).toFixed(2)}
                        </td>

                        {/* Mean + deviation show once */}
                        {i === 0 && (
                          <>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.mean_value}
                            </td>

                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.deviation_value}
                            </td>

                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.remark}
                            </td>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.accureacy_status
                                ? "Accepted"
                                : "Not Accepted"}
                            </td>
                            <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              <div className="action_icons">
                                {haveEditPermission && (
                                  <FontAwesomeIcon
                                    icon={faPen}
                                    onClick={() => {
                                      setEdit(true);
                                      setEditId(row.id);
                                    }}
                                  />
                                )}

                                {haveDeletePermission && (
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    onClick={() => openDeleteModal(row?.id)}
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr key={index}>
                      <td>
                        {(currentPage - 1) *
                          (data?.per_page || data?.data?.length || 0) +
                          index +
                          1}
                      </td>
                      <td>{formatDate(row.createdAt)}</td>
                      <td>{row.Instrument_Management?.instrument_name}</td>
                      <td>{row.Instrument_Management?.unique_id}</td>
                      <td>{row.Instrument_Management?.User?.name}</td>
                      <td>{row.weight_in_grams}</td>
                      <td>{row.std_value_in_grams}</td>
                      <td colSpan="4">No Observations</td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing {(data.current_page - 1) * data.per_page + 1} To{" "}
              {Math.min(data.current_page * data.per_page, data.total)} Of{" "}
              {data.total} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>

        {/* Edit */}
        {haveEditPermission && (
          <Intermediate_Check_Edit_Offcanvas
            show={showEdit}
            handleClose={() => setEdit(false)}
            id={showEditId}
          />
        )}

        {haveDeletePermission && (
          <Delete_Modal
            onHide={() => setShowDeleteModal(false)}
            show={showDeleteModal}
            confirmDelete={confirmDelete}
          />
        )}
        {/* <div className="permission_btn_holder">
          {success ? (
            <Success_Toster successText="Save Audit Successfully!" />
          ) : (
            <>
              <Button type="button" className="permission_btn No_btn">
                Reset
              </Button>

              <Button
                type="button"
                className="permission_btn Yes_btn"
                onClick={() => setSuccess(true)}
              >
                Save
              </Button>
            </>
          )}
        </div> */}
      </section>
    </>
  );
}

export default Intermediat_Check_table;
